export const resendTimeout = 60;
export const resendTimeoutStorageKey = 'signupEmailResendTimeout';
